import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DataLoadService } from "../../services/data-load.service";

/**
 * Full-screen state for a failed start-up load.
 *
 * The profile now comes from CloudInsurance, so `/get-current-user` can answer
 * 502. Without the profile the portal has no data to show, so the screen blocks
 * the app and offers a retry.
 */
@Component({
  selector: 'app-load-error',
  templateUrl: './load-error.component.html',
  styleUrls: ['./load-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoadErrorComponent {
  retrying = false;

  constructor(private dataLoadService: DataLoadService) {
  }

  get messageKey(): string {
    return this.dataLoadService.failedUpstream
      ? 'load-error.message-insurance-system'
      : 'load-error.message-generic';
  }

  async retry(): Promise<void> {
    if (this.retrying) {
      return;
    }

    this.retrying = true;

    try {
      await this.dataLoadService.retry();
    } finally {
      this.retrying = false;
    }
  }
}
